<div>
    <canvas id="assetPerformanceBarGraphCanvas" (change)="drawGraph($event)"></canvas>
</div>